/* eslint-disable */
import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styles from './FullWidthECGPreview.css'
import Beat from './Beats';
import Grid from './Grid'
import Waveform from './Waveform'
import * as Lib from '../../const'
import { CircularProgress } from '@material-ui/core';
import EcgLoader from 'legacy/containers/EcgLoader';

const FullWidthECGPreview = (props) => {
    const {
        ecgTitle = null,
        seconds = 30,
        width = seconds*Lib.PX_PER_SECOND,
        height = Lib.MV_BANDWIDTH * Lib.PX_PER_MV+1,
        inverted = false,
        mainsFreq = 60,
        sample = null,
        style = null,
        enableBeats = false,
        beats =[]
    } = props
    
    return (
        <div style={{height:`${height}`,...style}} className={styles.FullWidthECGPreviewContainer}>
            <svg width={width} height={`${height}px`} className={styles.previewGrid}>
                {ecgTitle && <text x="5" y="15" className={styles.LeadTitle}>{ecgTitle}</text>}
                {enableBeats && beats != [] && beats.map(beat => 
                    <Beat 
                        key ={beat}
                        capsule={false}
                        height={height}
                        samples={sample}
                        inverted={inverted}
                        index={beat[0]}
                        type={beat[1]}
                    />
                )}
                <g transform="translate(0,0)">
                <Grid
                    renderSmallGrid={true}
                    rowSeconds={seconds}
                    stripWidthPx={width}
                    height={height}
                />
                <Waveform
                    capsule={false}
                    height={height}
                    samples={sample}
                    inverted={inverted}
                    mainsFreq={mainsFreq}
                />
                </g>
            </svg>
        </div>
    )
}

export default FullWidthECGPreview



// WEBPACK FOOTER //
// ./src/views/pages/Annotation/components/FullWidthECGPreview/FullWidthECGPreview.jsx